import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { Icon, DatePicker, Button } from 'oxyrion-ui/lib';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import { connect } from '../../Store';
import { __ } from '../../Utils';

const Wrapper = styled.div`
  text-align: justify;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: ${rem(500)};
`;

const Text = styled.div`
  margin-bottom: ${rem(8)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const DatePickerWrapper = styled.div`
  margin-bottom: ${rem(10)};
  position: relative;
  width: 80%;
  margin-right: 40px;
`;

const StyledDatePicker = styled(DatePicker)``;

const CustomIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -30px;
  top: 10px;
`;

const SubmitWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 12px;
  right: 12px;
`;

class DeliveryDateChange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment(),
    };
  }

  componentDidMount() {
    this.setState({
      date: this.props.value,
      minDate: this.props.lowestDeliveryDate,
    });
  }

  handleChange(e) {
    this.setState({
      date: e,
    });
  }

  submit() {
    const { onSubmit } = this.props;
    const { date } = this.state;

    onSubmit(date);
  }

  render() {
    const { label } = this.props;
    const { date, minDate } = this.state;

    return (
      <Wrapper>
        <Text>
          <p>
            {__('Najskorší dátum dodania je')}
            <b>{` ${label}.`}</b>
          </p>

          <Text>
            <p>
              {__(
                'Pre zmenu na neskorší dátum, prosím použite tento formulár a stlačte tlačidlo',
              )}
              <b>{` "${__('Zmeniť dátum.')}"`} </b>
            </p>
          </Text>
        </Text>

        <DatePickerWrapper>
          <StyledDatePicker
            value={date}
            minDate={minDate}
            isClearable={false}
            onChange={e => this.handleChange(e)}
          />
          <CustomIconWrapper>
            <Icon name="clock" size="l" color={baseTheme.color.primary} />
          </CustomIconWrapper>
        </DatePickerWrapper>
        <SubmitWrapper>
          <Button primary onClick={() => this.submit()}>
            {__('Zmeniť dátum')}
          </Button>
        </SubmitWrapper>
      </Wrapper>
    );
  }
}

DeliveryDateChange.propTypes = {
  onSubmit: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string,
  lowestDeliveryDate: PropTypes.string,
};

DeliveryDateChange.defaultProps = {
  onSubmit: () => {},
  value: '',
  label: '',
  lowestDeliveryDate: '',
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(DeliveryDateChange);



// WEBPACK FOOTER //
// ./src/Components/DeliveryDateChange/index.jsx